/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { SERVICE_TYPES } from 'shared';

import { PlanComputeCreateRequest } from '../../../../types/su-plan/requests/PlanComputeCreateRequest';

export type CreatePlanComputeDialogValues = PlanComputeCreateRequest;

export const formInitialValues: CreatePlanComputeDialogValues = {
  name: '',
  cpu: 0,
  memory: 0,
  replicaMin: 0,
  replicaMax: 0,
  replicaDefault: 0,
  serviceType: 'postgres',
  isVisible: false,
};

export const validationSchema = Yup.object({
  name: Yup.string().required('empty'),
  cpu: Yup.number().positive('not_positive').required('empty'),
  memory: Yup.number().positive('not_positive').required('empty'),
  replicaMin: Yup.number()
    // .positive("not_positive")
    .integer()
    .required('empty'),
  replicaMax: Yup.number()
    // .positive("not_positive")
    .integer()
    .required('empty')
    .min(Yup.ref('replicaMin'), 'more_than_or_equal'),
  replicaDefault: Yup.number()
    // .positive("not_positive")
    .integer()
    .min(Yup.ref('replicaMin'), 'more_than_or_equal')
    .max(Yup.ref('replicaMax'), 'less_than_or_equal')
    .required('empty'),

  serviceType: Yup.string()
    .oneOf([...SERVICE_TYPES])
    .required('empty'),
  isVisible: Yup.boolean(),
});
